export default __webpack_public_path__ + "static/media/annex10.596510c6.png";